// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1hwkA","button__delete":"Button_button__delete__3V3ka","button__icon":"Button_button__icon__1FZwV"};